<pre>{{status | json}}</pre>